// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { Tooltip as UiTooltip } from '@plesk/ui-library';

export interface ITooltipProps {
    shown: boolean;
}

export type TooltipProps =
    ITooltipProps &
    React.ComponentProps<typeof UiTooltip>;

export const Tooltip: React.FC<TooltipProps> = ({
    shown = true,
    children,
    ...props
}) => {
    if (shown) {
        return (
            <UiTooltip {...props}>
                {children}
            </UiTooltip>
        );
    }

    return children;
};
